import { MenuList } from '@reach/menu-button';
import PropTypes from 'prop-types';

import './styles/dropdownMenuStyles.css';
import './styles/menuStyles.css';

//  This component is deprecated in favor of the <MenuButton/> in the __pds folder

const DropdownMenu = ({ children, size, ...rest }) => {
  let sizeStyles;

  if (size === 'large') {
    sizeStyles = { maxWidth: 588, width: `${100 / 2}vw` };
  } else if (size === 'small') {
    sizeStyles = { maxWidth: 294, width: `${100 / 4}vw` };
  } else {
    sizeStyles = { maxWidth: 392, width: `${100 / 3}vw` };
  }

  return (
    <MenuList
      {...rest}
      className="bg-white border border-solid border-gray-3 rounded shadow-dropdown mt-1 overflow-hidden dd-styles"
      style={sizeStyles}
    >
      {children}
    </MenuList>
  );
};

DropdownMenu.defaultProps = {
  size: 'default',
};

DropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Set the width and maximum width of the menu overlay (list of items)
   */
  size: PropTypes.oneOf(['default', 'large', 'small']),
};

export default DropdownMenu;
